import EncryptionUtils from "./EncryptionUtils";

const storeKey = "repairspots_data";

const storageMechanism = window.sessionStorage;

const setItem = (key, value) => {
  const encodedValue = EncryptionUtils.encode(JSON.stringify(value));
  storageMechanism.setItem(key, encodedValue);
};

const getItem = (key) => {
  const value = storageMechanism.getItem(key);
  if (value) {
    return JSON.parse(EncryptionUtils.decode(value));
  }

  return null;
};

const removeItem = (key) => {
  storageMechanism.removeItem(key);
};

const clearAll = () => {
  storageMechanism.clear();
};

export default {
  setItem,
  getItem,
  removeItem,
  clearAll,
  storeKey,
};
